import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

export const AIContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
});

export const MenuItem = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  width: '100%',
});

export const GenerateAIMenuItem = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
});

export const GenerateAIMenuItemRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const ShortcutText = styled('span')({
  fontSize: '12px',
  color: 'rgba(0, 40, 58, 0.6)',
  fontWeight: 'normal',
});

export const PromptMenuItem = styled('div')({ padding: '8px 16px' });

export const PromptTextarea = styled(TextField)({});

export const ButtonGroup = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  marginTop: '6px',
});
